// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w63M","name":"styles_name__2yplg","phone":"styles_phone__H-sj4"};